import { httpClient } from "../../../shared/api/httpClient";
import type { PaginatedResponse } from "../../../shared/api/pagination";
import type {
  CompanyRegistration,
  CompanyRegistrationStatus,
} from "../model/types";

export const fetchCompanyRegistrations = async (
  page = 1,
  pageSize = 20,
  status?: CompanyRegistrationStatus,
  search?: string,
): Promise<PaginatedResponse<CompanyRegistration>> =>
  (
    await httpClient.get<PaginatedResponse<CompanyRegistration>>(
      "/seller/company-registration-requests",
      {
        params: {
          page,
          page_size: pageSize,
          status,
          search: search?.trim() || undefined,
        },
      },
    )
  ).data;

export const approveCompanyRegistration = async (
  registrationId: number,
): Promise<CompanyRegistration> =>
  (
    await httpClient.post<CompanyRegistration>(
      `/seller/company-registration-requests/${registrationId}/approve`,
    )
  ).data;

export const rejectCompanyRegistration = async (
  registrationId: number,
  rejectionReason: string,
): Promise<CompanyRegistration> =>
  (
    await httpClient.post<CompanyRegistration>(
      `/seller/company-registration-requests/${registrationId}/reject`,
      { rejection_reason: rejectionReason },
    )
  ).data;
